var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-text",attrs:{"id":"floatingBottomText"}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('strong',[_vm._v(_vm._s(_vm.strong))])])
}
var staticRenderFns = []

export { render, staticRenderFns }